import { put, call, takeEvery } from 'redux-saga/effects';
import { axiosInstance, apiURL } from 'config';
import toast from 'react-hot-toast';

import {
  loadAdvertisementsRequested,
  loadAdvertisementsSuccess,
  loadAdvertisementsFail,
  updateAdvertisementsRequested,
  updateAdvertisementsSuccess,
  updateAdvertisementsFail,
  deleteAdvertisementsRequested,
  deleteAdvertisementsSuccess,
  deleteAdvertisementsFail,
  storeAdvertisementsRequested,
  storeAdvertisementsSuccess,
  storeAdvertisementsFail,
  storeAdvertisementsImageRequested,
  storeAdvertisementsImageSuccess,
  storeAdvertisementsImageFail,
} from './advertisementsSlice';

export function* loadAdvertisementsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/index-advert?searchString=${
        action?.payload?.filters?.query ?? ''
      }&page=${action.payload.page}&pageSize=${action.payload.perPage}`,
      action.payload
    );
    yield put(loadAdvertisementsSuccess(data));
  } catch (error: any) {
    yield put(loadAdvertisementsFail(error.message));
  }
}

//update advertisements
export function* updateAdvertisementsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.put,
      `${apiURL}/edit-advert`,
      action.payload?.values
    );
    if (data?.succeeded) {
      yield put(updateAdvertisementsSuccess(data));
      if (action?.payload?.values?.image) {
        const image = action?.payload?.values?.image;

        if (image instanceof Blob || image instanceof File) {
          const formData = new FormData();

          formData.append('Image', image);

          yield call(storeAdvertisementsImageEffect, {
            payload: {
              id: data?.result.id,
              content: formData,
            },
            type: '',
          });
        }
      }
      toast.success('Advertisements edited  successfully');
      action.payload?.navigate('/advertisements');
    } else {
      toast.error('Advertisements edit failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(updateAdvertisementsFail(error.message));
  }
}

//delete advertisement
export function* deleteAdvertisementsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.delete,
      `${apiURL}/delete-advert?Id=${action.payload.item?.id}`,
      action.payload
    );

    if (data?.result) {
      yield put(deleteAdvertisementsSuccess(data));
      toast.success('Advertisements deleted successfully');
    } else {
      toast.error('Advertisements delete failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(deleteAdvertisementsFail(error.message));
  }
}

//store advertisement
export function* storeAdvertisementsEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/create-advert`,
      action.payload
    );
    if (data?.result) {
      yield put(storeAdvertisementsSuccess(data));
      if (action.payload?.image) {
        const formData = new FormData();
        formData.append('Image', action.payload?.image);
        yield call(storeAdvertisementsImageEffect, {
          payload: {
            id: data?.result,
            content: formData,
          },
          type: '',
        });
      }
      yield call(loadAdvertisementsEffect, {
        payload: { perPage: 15, page: 1 },
        type: '',
      });
      toast.success('Advertisements created successfully');
    } else {
      toast.error('Advertisements create failed! ', data?.errors);
    }
  } catch (error: any) {
    yield put(storeAdvertisementsFail(error.message));
  }
}

//store advertisementImage
export function* storeAdvertisementsImageEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.post,
      `${apiURL}/set-image-to-advert?Id=${action.payload.id}`,
      action.payload?.content,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    if (data?.succeeded) {
      yield put(storeAdvertisementsImageSuccess(data));
    }
  } catch (error: any) {
    yield put(storeAdvertisementsImageFail(error.message));
  }
}

export function* advertisementsSaga(): Generator<any, void, any> {
  yield takeEvery(loadAdvertisementsRequested, loadAdvertisementsEffect);
  yield takeEvery(storeAdvertisementsRequested, storeAdvertisementsEffect);
  yield takeEvery(
    storeAdvertisementsImageRequested,
    storeAdvertisementsImageEffect
  );
  yield takeEvery(updateAdvertisementsRequested, updateAdvertisementsEffect);
  yield takeEvery(deleteAdvertisementsRequested, deleteAdvertisementsEffect);
}
